export default "__VITE_ASSET__C7N0OR2I__"